import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';
import { TServerSendResponse, TServerSendRequest } from '../../types';

export const useSetPlayerContactPreferences = () => {
    const send = useGenericSend();

    return useCallback(async (contactPreferences: Types.IContactPreferenceItem[]): Promise<TServerSendResponse> => {
        const { data } = await send<
            TServerSendRequest<{ contactPreferences: Types.IContactPreferenceItem[] }>, TServerSendResponse
        >({
            ID: 35513,
            description: 'Set player contact preferences',
            responses: [35514, 35515],
            contactPreferences
        });

        return data;
    }, [send]);
};
